




















































































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import PayrollRunTimesheetFilter from '@/components/Payroll/PayrollRunTimesheetFilter.vue';
import TimesheetDto from '@/models/Timesheets/TimesheetDto';
import TimesheetStatus from '@/components/Timesheets/Display/TimesheetStatus.vue';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';
import EntityType from '@/models/Shared/EntityType';
import ComponentLocation from '@/models/Shared/ComponentLocation';
import PayrollRunStatus from '@/models/Payroll/PayrollRunStatus';
import { PayrollRunDetailsModule, AVAILABLE_PAGE_SIZE } from '@/store/modules/payrollRunDetails';

@Component({
    name: 'PayrollRunTimesheets',
    components: { PayrollRunTimesheetFilter, TimesheetStatus },
})
export default class extends GiganautVue {
    @Prop({ required: true }) runId!: string;
    @Prop({ required: true }) runStatus!: number;
    @Prop({ default: '' }) providerName!: string;
    // Payroll go-live floor (ISO date-time or null) — the BROWSE tab only
    // shows approved timesheets worked after this date. Null means the
    // agency isn't configured yet and the available list is empty by design.
    @Prop({ default: null }) availableFrom!: string | null;

    activeTab = 0;
    // Available-tab selections accumulate ACROSS pages — tick rows on page 1,
    // page forward, tick more; "Add Selected (N)" carries the running total.
    selectedAvailableIds: string[] = [];
    selectedIncluded: TimesheetDto[] = [];
    selectedIncludedIds: string[] = [];
    addAllDialog = false;
    markSentDialog = false;
    markSentTimesheet: TimesheetDto | null = null;
    AVAILABLE_PAGE_SIZE = AVAILABLE_PAGE_SIZE;
    // v-data-table server-side pager state; page changes fetch via the watcher.
    browseOptions: { page: number; itemsPerPage: number } = { page: 1, itemsPerPage: AVAILABLE_PAGE_SIZE };

    browseHeaders = [
        { text: '', value: 'select', sortable: false, width: 50 },
        { text: 'Ref', value: 'sequenceNumber', sortable: false, width: 70 },
        { text: 'Position', value: 'shift.bookingRole.position.name', sortable: false },
        { text: 'Desk', value: 'shift.bookingRole.desk.name', sortable: false },
        { text: this.Labels.location, value: 'location.brandName', sortable: false },
        { text: this.Labels.worker, value: 'worker.person.lastName', sortable: false },
        { text: 'Date', value: 'startAt', sortable: false },
        { text: 'Status', value: 'status', sortable: false, width: 110 },
        { text: 'Actions', sortable: false, width: 70 },
    ];

    includedHeaders = [
        { text: 'Ref', value: 'sequenceNumber', sortable: false, width: 70 },
        { text: 'Position', value: 'shift.bookingRole.position.name', sortable: false },
        { text: 'Desk', value: 'shift.bookingRole.desk.name', sortable: false },
        { text: this.Labels.location, value: 'location.brandName', sortable: false },
        { text: this.Labels.worker, value: 'worker.person.lastName', sortable: false },
        { text: 'Date', value: 'startAt', sortable: false },
        { text: 'Payroll Status', value: 'externalPayrollSystemId', sortable: false, width: 190 },
        { text: 'Actions', sortable: false, width: 70 },
    ];

    StatusDisplayLocation = StatusDisplayLocation;
    EntityType = EntityType;
    ComponentLocation = ComponentLocation;

    get availableTimesheets(): TimesheetDto[] { return PayrollRunDetailsModule.availableTimesheets; }
    get availableTotal(): number { return PayrollRunDetailsModule.availableTotal; }
    get availablePage(): number { return PayrollRunDetailsModule.availablePage; }
    get includedTimesheets(): TimesheetDto[] { return PayrollRunDetailsModule.timesheets; }
    get loadingAvailable(): boolean { return PayrollRunDetailsModule.availableTimesheetsLoading; }
    get loadingIncluded(): boolean { return PayrollRunDetailsModule.timesheetsLoading; }
    get saving(): boolean { return PayrollRunDetailsModule.saving; }

    // "Showing 51–100 of 312" for the browse caption.
    get availableRangeLabel(): string {
        if (this.availableTotal === 0) return 'Showing 0';
        const start = (this.availablePage - 1) * AVAILABLE_PAGE_SIZE + 1;
        const end = Math.min(this.availablePage * AVAILABLE_PAGE_SIZE, this.availableTotal);
        return `Showing ${start}–${end} of ${this.availableTotal}`;
    }

    // Page-scoped selection state for the header checkbox.
    get pageIds(): string[] {
        return this.availableTimesheets.map(t => t.id);
    }
    get allPageSelected(): boolean {
        return this.pageIds.length > 0 && this.pageIds.every(id => this.selectedAvailableIds.includes(id));
    }
    get somePageSelected(): boolean {
        return this.pageIds.some(id => this.selectedAvailableIds.includes(id));
    }

    // Mutations are only allowed while the run is editable. Once it's been
    // submitted upstream we're past the point of changing what's on it.
    get canAdd(): boolean {
        return this.runStatus === PayrollRunStatus.Draft || this.runStatus === PayrollRunStatus.Submitting;
    }
    get canRemove(): boolean {
        return this.canAdd;
    }
    get canSend(): boolean {
        return this.canAdd;
    }

    // Count of bound timesheets that don't yet have an external_payroll_system_id.
    // Drives the Send button label/disabled state.
    get unsentCount(): number {
        return this.includedTimesheets.filter(t => !t.externalPayrollSystemId).length;
    }

    // Mark Sent is a pre-sync correction: once the run reaches Syncing Data
    // (or beyond — Completed/Failed sort above it) what was sent is settled
    // history and the backend refuses. Mirrors MarkTimesheetSent's guard.
    get canMarkSent(): boolean {
        return this.runStatus < PayrollRunStatus.SyncingData;
    }

    // "Firstname Lastname" for the confirm dialog, if the person is loaded.
    get markSentWorkerName(): string {
        return this.markSentTimesheet ? this.workerName(this.markSentTimesheet) : '';
    }

    // Provider label used in the Send button — derived from the active
    // integration name so a different adapter just relabels automatically.
    get providerLabel(): string {
        return this.providerName || 'payroll system';
    }

    // Human-readable go-live floor for the browse-tab captions.
    get isFilterActive(): boolean {
        const f = PayrollRunDetailsModule.availableFilter;
        return !!(f.branchId || f.deskId || f.workerId || f.from);
    }

    get availableFromLabel(): string {
        if (!this.availableFrom) return '';
        const d = new Date(this.availableFrom);
        return isNaN(d.getTime()) ? '' : d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
    }

    // " (worked after 1 Jun 2026)" — appended to the empty-state message so
    // a clerk looking for an older timesheet understands why it's absent.
    get availableFromSuffix(): string {
        return this.availableFromLabel ? ` (worked after ${this.availableFromLabel})` : '';
    }

    @Watch('runId', { immediate: true })
    async onRunIdChange(newVal: string) {
        if (!newVal) return;
        // Lazy — no-ops if already loaded (and not invalidated). The store
        // marks both as loaded after first fetch; mutations elsewhere
        // invalidate via the matching setXLoaded(false) calls.
        await Promise.all([
            PayrollRunDetailsModule.ensureAvailableTimesheetsLoaded(newVal),
            PayrollRunDetailsModule.ensureTimesheetsLoaded(newVal),
        ]);
    }

    // Pager → fetch. Skips when the pager already matches the store's page
    // (initial mount, and the echo after onStorePageChange syncs the pager).
    @Watch('browseOptions.page')
    async onBrowsePageChange(newPage: number) {
        if (!this.runId || !newPage || newPage === this.availablePage) return;
        await PayrollRunDetailsModule.fetchAvailableTimesheets({ runId: this.runId, page: newPage });
    }

    // Store → pager. Covers the store stepping back a page when the current
    // page empties out (rows got bound and the offset ran past the end).
    @Watch('availablePage')
    onStorePageChange(newPage: number) {
        if (newPage && this.browseOptions.page !== newPage) {
            this.browseOptions.page = newPage;
        }
    }

    workerName(item: TimesheetDto): string {
        const p = item.worker && (item.worker as any).person;
        if (!p) return '';
        return `${p.firstName || ''} ${p.lastName || ''}`.trim();
    }

    position(item: TimesheetDto): string {
        const br = item.shift && (item.shift as any).bookingRole;
        return (br && br.position && br.position.name) ? br.position.name : '';
    }

    desk(item: TimesheetDto): string {
        const br = item.shift && (item.shift as any).bookingRole;
        return (br && br.desk && br.desk.name) ? br.desk.name : '';
    }

    location(item: TimesheetDto): string {
        return (item.location && (item.location as any).brandName) ? (item.location as any).brandName : '';
    }

    bookingId(item: TimesheetDto): string {
        const br = item.shift && (item.shift as any).bookingRole;
        return (br && br.bookingId) ? br.bookingId : '';
    }

    toggleAvailableSelection(id: string, selected: boolean) {
        const idx = this.selectedAvailableIds.indexOf(id);
        if (selected && idx === -1) this.selectedAvailableIds.push(id);
        if (!selected && idx > -1) this.selectedAvailableIds.splice(idx, 1);
    }

    // Header checkbox — (de)selects the visible page only; selections on
    // other pages are left untouched.
    togglePageSelection(selected: boolean) {
        if (selected) {
            const merged = new Set([...this.selectedAvailableIds, ...this.pageIds]);
            this.selectedAvailableIds = Array.from(merged);
        } else {
            this.selectedAvailableIds = this.selectedAvailableIds.filter(id => !this.pageIds.includes(id));
        }
    }

    toggleIncludedSelection(id: string, selected: boolean) {
        const idx = this.selectedIncludedIds.indexOf(id);
        if (selected && idx === -1) this.selectedIncludedIds.push(id);
        if (!selected && idx > -1) this.selectedIncludedIds.splice(idx, 1);
    }

    updateSelectedIncludedIds(items: TimesheetDto[]) {
        // Don't allow already-sent timesheets to be selected for removal.
        this.selectedIncludedIds = items
            .filter(t => !t.externalPayrollSystemId)
            .map(t => t.id);
    }

    async refreshAvailable() {
        await PayrollRunDetailsModule.fetchAvailableTimesheets({ runId: this.runId });
    }

    async refreshIncluded() {
        await PayrollRunDetailsModule.fetchTimesheets(this.runId);
    }

    async addSelected() {
        if (this.selectedAvailableIds.length === 0) return;
        // The store action refetches the current available page (stepping back
        // if this page emptied) and the included list.
        await PayrollRunDetailsModule.addTimesheets({
            runId: this.runId,
            timesheetIds: [...this.selectedAvailableIds],
        });
        this.selectedAvailableIds = [];
    }

    async onConfirmAddAll() {
        await PayrollRunDetailsModule.addAllAvailable(this.runId);
        this.addAllDialog = false;
        this.selectedAvailableIds = [];
    }

    openMarkSent(item: TimesheetDto) {
        this.markSentTimesheet = item;
        this.markSentDialog = true;
    }

    async onConfirmMarkSent() {
        if (!this.markSentTimesheet) return;
        await PayrollRunDetailsModule.markTimesheetSent({
            runId: this.runId,
            timesheetId: this.markSentTimesheet.id,
        });
        this.markSentDialog = false;
        this.markSentTimesheet = null;
    }

    async onSend() {
        await PayrollRunDetailsModule.submitTimesheets(this.runId);
        await this.refreshIncluded();
    }

    async removeSelected() {
        if (this.selectedIncludedIds.length === 0) return;
        // One batch call — the backend removes everything removable in a
        // single guarded update and reports any rows it had to skip (e.g.
        // already pushed to the payroll system).
        await PayrollRunDetailsModule.unaddTimesheets({
            runId: this.runId,
            timesheetIds: [...this.selectedIncludedIds],
        });
        this.selectedIncludedIds = [];
        this.selectedIncluded = [];
    }
}
